import { render, staticRenderFns } from "./SubscribeBenefits2026.vue?vue&type=template&id=71846278&scoped=true&"
import script from "./SubscribeBenefits2026.vue?vue&type=script&lang=js&"
export * from "./SubscribeBenefits2026.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeBenefits2026.vue?vue&type=style&index=0&id=71846278&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71846278",
  null
  
)

export default component.exports